import React from 'react';
import { Link } from 'react-router-dom';

export default function SingleCourse({ link, imageSrc, title, desc }) {
  return (
    <div className='col-md-6'>
      <Link to={`/courses/${link}`} class='blog-post-link'>
        <img
          src={imageSrc}
          alt='course-image'
          class='blog-post-thumbnail img-fluid'
        />
        <h4 style={{ marginTop: '10px' }}>{title}</h4>
      </Link>
      <p class='blog-post-meta' style={{'textAlign': 'justify'}}>
        <span class='post-published-date'>{desc}</span>
      </p>
    </div>
  );
}
